export default {
    data() {
        return {
            tableIdentifier: null,
            gridWidthOptions: null,
        }
    },
    async created() {
        this.loading = true;
        await this.setGridWidthOptions();
        this.loading = false;
    },
    methods: {
        async setGridWidthOptions(tableIdentifier) {
            const localTableIdentifier = tableIdentifier || this.tableIdentifier;

            if (localTableIdentifier) {
                const { data } = await this.$api.gridOptions.list(localTableIdentifier);
                this.gridWidthOptions = data.data.ColumnData;
            }

            return this.gridWidthOptions;
        },
        getColumnDefsWithWidths(columnDefs, gridWidthOptions) {
            const localGridWidthOptions = gridWidthOptions || this.gridWidthOptions;
            
            if (localGridWidthOptions) {
                let index = 0;

                columnDefs.forEach((columnDef) => {
                    if (columnDef.hide) {
                        return true;
                    }

                    const columnSize = localGridWidthOptions.find((columnOptions) =>
                        columnOptions.ColumnOrder === index
                    );
                    if (columnSize && columnSize.ColumnSize) {
                        columnDef.minWidth = columnSize.ColumnSize;
                        columnDef.width = columnSize.ColumnSize;

                        if (columnSize.SizeColumnsToFit) {
                            columnDef.maxWidth = columnSize.ColumnSize;
                        }
                    }
                    
                    index++;
                });
            }

            return columnDefs;
        }
    },
};
